import { motion } from "framer-motion";
import { SiBilibili, SiXiaohongshu } from "react-icons/si";

export default function CharacterCard({ character, delay, initialAnim }) {
    return (
        <motion.div
            className="p-4 flex flex-col md:flex-row items-center md:items-star"
            initial={initialAnim}
            whileInView={{ opacity: 1, x: 0, y: 0 }}
            viewport={{ once: true }}
            transition={{ type: "spring", stiffness: 100, damping: 20, delay }}
        >
            {/* 左側：キャラクター画像 */}
            <div className="flex-shrink-0 mb-4 md:mb-0 md:mr-6">
                <img
                    src={character.image}
                    alt={character.name}
                    className="bg-white w-32 h-32 rounded-full object-cover p-2 shadow"
                />
            </div>

            {/* 右側：テキストとアイコン */}
            <div className="flex flex-col text-left w-full">
                <h3 className="font-bold text-xl mb-2 flex items-center gap-2">
                    {character.name}
                    {character.bilibili && (
                        <a
                            href={character.bilibili}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-[#00A1D6] hover:text-[#0085b2] transition text-base leading-none"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <SiBilibili />
                        </a>
                    )}
                    {character.xiaohongshu && (
                        <a
                            href={character.xiaohongshu}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-[#FF2442] hover:text-[#cc1a33] transition text-base leading-none"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <SiXiaohongshu />
                        </a>
                    )}
                </h3>
                <p className="text-base text-[#b5435f] border-b border-dotted border-[#b5435f] pb-1">
                    {character.sub}
                </p>

                <p
                    className="leading-snug tracking-tight text-left break-words text-sm w-full mt-2"
                    style={{ whiteSpace: "normal" }}
                >
                    {character.desc}
                </p>
            </div>
        </motion.div>
    );
}
